const generateUUID = (): string => {
  // Generate a random 4-digit hex number
  const randomHex = () => Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);

  // Generate the UUID using the randomHex function
  return `${randomHex()}${randomHex()}-${randomHex()}-${randomHex()}-${randomHex()}-${randomHex()}${randomHex()}${randomHex()}`;
};

export default generateUUID;